import { render, staticRenderFns } from "./PessoaEquipamento.vue?vue&type=template&id=4e1fd778&scoped=true&"
import script from "./PessoaEquipamento.vue?vue&type=script&lang=js&"
export * from "./PessoaEquipamento.vue?vue&type=script&lang=js&"
import style0 from "./PessoaEquipamento.vue?vue&type=style&index=0&id=4e1fd778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1fd778",
  null
  
)

export default component.exports